// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3-DIx","info":"UpdateTermsInfo_info__3aNmm"};